'use strict';

angular.module('ntmApp').factory('ProfileGrid', function () {

    function ProfileGrid() {

        var self = this;

        self.getGrid = function () {
            return;
        };

    }

    return (ProfileGrid);
});